"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styles = require("./styles.scss");
const md_1 = require("react-icons/md");
exports.default = ({ Steps, CurrentStep }) => {
    let currentIndex = Steps.indexOf(CurrentStep);
    return (React.createElement("div", { style: {
            margin: "0px 20px",
            position: "relative",
            display: "flex",
            justifyContent: "space-between"
        } },
        React.createElement("div", { style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            } },
            React.createElement("div", { style: { height: 2, background: "#E9E7E7" } })),
        Steps.map((val, index) => (React.createElement(SingleStep, { label: val, index: index, complete: index < currentIndex })))));
};
const SingleStep = ({ label, complete, index }) => {
    var _a;
    let indexLabel = (index + 1).toString();
    return (React.createElement("div", { style: { display: "flex", flexDirection: "column", zIndex: 5 } },
        React.createElement("div", { style: { height: 20 } }),
        React.createElement("div", { style: {
                width: 60,
                height: 60,
                background: complete ? "#63A555" : "#000",
                color: "white",
                borderRadius: 30,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column"
            } },
            React.createElement("div", { className: styles.stepIcon }, complete ? React.createElement(md_1.MdCheck, { size: 35 }) : indexLabel)),
        React.createElement("div", { className: styles.stepLabel }, (_a = label === null || label === void 0 ? void 0 : label.toUpperCase()) !== null && _a !== void 0 ? _a : "")));
};
//# sourceMappingURL=index.js.map